<template>
  <div>    
      <div class="bottom d-flex justify-content-around backColor">
        
          <button type="button" class="btn btn-success" style=" margin: 10px 0px 10px 0px;" 
              @click="app.loadFromLocalStorage()" >Cargar localstorage</button>

          <button type="button" class="btn btn-warning" style=" margin: 10px 0px 10px 0px;"
              @click="app.saveToLocalStorage()" >Guardar localstorage</button>

          <button type="button" class="btn btn-danger" style=" margin: 10px 0px 10px 0px;"
              @click="app.deleteFromLocalStorage()" >Borrar localstorage</button>              
              
      </div> 
  </div>
</template>

<script>

import jQuery from 'jquery'
import { app } from '../application.js'

export default {
  name: 'developBarComponent',
  props: {},
  data () {
     return {app: app}
  },
  coputed:{
    
  },
  methods:{}
}
</script>

<style scoped>
  .center {text-align:center}
  .bottom {position:fixed;bottom:0px;width:100%;}
  .backColor{background-color:grey;}
</style>
